export default {
    header: function (_a) {
        var props = _a.props, state = _a.state;
        return ({
            class: [
                // Flex
                'tw-flex tw-items-center',
                { 'tw-justify-between': !props.toggleable },
                // Colors
                'tw-text-white',
                'tw-bg-primary-500 hover:tw-bg-primary-600',
                'tw-border tw-border-primary-500 hover:tw-border-primary-600',
                //Shape
                'tw-rounded-tl-md tw-rounded-tr-md',
                { 'tw-rounded-bl-md tw-rounded-br-md': state.d_collapsed },
                // Conditional Spacing
                { 'tw-p-5': !props.toggleable, 'tw-py-2 tw-px-3': props.toggleable },
                // Transition
                'tw-transition tw-duration-200',
            ],
        });
    },
    headerActions: function (_a) {
        var props = _a.props;
        return ({
            class: [{ 'tw-order-1': props.toggleable }],
        });
    },
    title: function (_a) {
        var props = _a.props;
        return ({
            class: [{ 'tw-order-2': props.toggleable }, 'tw-leading-none tw-font-bold'],
        });
    },
    pctogglebutton: function (_a) {
        var props = _a.props;
        return ({
            root: {
                class: [
                    // Positioning
                    'tw-relative',
                    // Flexbox alignment
                    'tw-inline-flex tw-items-center tw-justify-center tw-text-center',
                    // Line height
                    'tw-leading-[normal]',
                    // Size
                    'tw-size-10 tw-min-w-10 tw-px-0 tw-py-[0.625rem]',
                    // Shape
                    'tw-rounded-[50%] tw-rounded-full',
                    // Background and border
                    'tw-bg-transparent tw-border-transparent',
                    // Text color
                    'tw-text-white',
                    // Focus states
                    'focus:tw-outline-none focus:tw-outline-offset-0 focus:tw-ring focus:tw-ring-gray-400/50 dark:focus:tw-ring-gray-300/50',
                    // Hover effect
                    'hover:tw-bg-gray-300/20',
                    // Transition effects
                    'tw-transition tw-duration-200 tw-ease-in-out',
                    // Cursor and overflow
                    'tw-cursor-pointer tw-overflow-hidden tw-select-none',
                    // Label visibility
                    '[&>[data-pc-section=label]]:tw-w-0 [&>[data-pc-section=label]]:tw-invisible',
                    // // Toggleable header
                    { 'tw-pointer-events-none': props.toggleable },
                ],
            },
        });
    },
    content: {
        class: [
            // Spacing
            'tw-p-5',
            // Shape
            'tw-border tw-border-t-0 last:tw-rounded-br-md last:tw-rounded-bl-md',
            //Color
            'tw-border-gray-200 dark:tw-border-gray-700',
            'tw-bg-white dark:tw-bg-gray-900',
            'tw-text-gray-700 dark:tw-text-gray-0/80',
        ],
    },
    footer: {
        class: [
            // Spacing
            'tw-py-3 tw-p-5',
            // Shape
            'tw-border tw-border-t-0 tw-rounded-br-md tw-rounded-bl-md',
            //Color
            'tw-border-gray-200 dark:tw-border-gray-700',
            'tw-bg-gray-0 dark:tw-bg-gray-900',
            'tw-text-gray-700 dark:tw-text-gray-0/80',
        ],
    },
    transition: {
        enterFromClass: 'tw-max-h-0',
        enterActiveClass: 'tw-overflow-hidden tw-transition-[max-height] tw-duration-500 tw-ease-[cubic-bezier(0.42,0,0.58,1)]',
        enterToClass: 'tw-max-h-[1000px]',
        leaveFromClass: 'tw-max-h-[1000px]',
        leaveActiveClass: 'tw-overflow-hidden tw-transition-[max-height] tw-duration-200 tw-ease-[cubic-bezier(0,1,0,1)]',
        leaveToClass: 'tw-max-h-0',
    },
};
